import { render, staticRenderFns } from "./ProductListImageArea.vue?vue&type=template&id=85be46ea&scoped=true&"
import script from "./ProductListImageArea.vue?vue&type=script&lang=ts&"
export * from "./ProductListImageArea.vue?vue&type=script&lang=ts&"
import style0 from "./ProductListImageArea.vue?vue&type=style&index=0&id=85be46ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85be46ea",
  null
  
)

export default component.exports